<template>
    <transition  >
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right float-left">
                        <ol class="breadcrumb m-0"> 
                            <li class="breadcrumb-item active">Accounts</li>
                            <li class="breadcrumb-item"><a href="javascript: void(0);">Account Ledger Create Deafult Settings </a></li>
                            
                        </ol>
                    </div>
                    <div class="page-title-right float-right"> 
                        <button type="button" class="btn btn-primary float-right" style="margin-right: 5px;" @click="createModal()">
                            <i class="mdi mdi-plus-outline"></i> Create New
                        </button> 
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <Modal @close="createModal()" :modalActive="modalActive">
            <div class="modal-content scrollbar-width-thin account_groups">
                <div class="modal-header"> 
                    <button @click="createModal()" type="button" class="btn btn-default">X</button>
                </div>
                <form @submit.prevent="submitLedgerCreateDefaultSettingsForm()" enctype="multipart/form-data" >
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="form-group col-md-12">
                                        <label for="type_category">Account Category *</label> <br>
                                        <Multiselect 
                                            class="form-control border" 
                                            mode="single"
                                            v-model="form.type_category"
                                            placeholder="--- Select Type Category ---"
                                            :searchable="true" 
                                            :filter-results="true"
                                            :options="type_category_options"
                                            :classes="multiclasses"
                                            :close-on-select="true" 
                                            :min-chars="1"
                                            :resolve-on-load="false"
                                            :create-option="true" 
                                            v-if="renderOptionComponent"
                                        /> 
                                        <div class="invalid-feedback" v-if="errors.type_category">
                                            {{errors.type_category[0]}}
                                        </div>
                                    </div>

                                    <div class="form-group col-md-12">
                                        <label for="acc_type">Account Type *</label> <br>
                                        <Multiselect 
                                            class="form-control border" 
                                            mode="single"
                                            v-model="form.acc_type"
                                            placeholder="--- Select Account Type ---"
                                            :searchable="true" 
                                            :filter-results="true"
                                            :options="acc_type_options"
                                            :classes="multiclasses"
                                            :close-on-select="true" 
                                            :min-chars="1"
                                            :resolve-on-load="false" 
                                            :create-option="true" 
                                            v-if="renderOptionComponent"
                                        /> 
                                        <div class="invalid-feedback" v-if="errors.acc_type">
                                            {{errors.acc_type[0]}}
                                        </div>
                                    </div>

                                    <div class="form-group col-md-12">
                                        <label for="type_id">Type for Ledger Create *</label> <br>                                          
                                        <treeselect 
                                            v-model="form.type_id"
                                            :multiple="false" 
                                            :always-open="false"
                                            :options="ledger_account_types"
                                            :normalizer="normalizer"
                                            :value-consists-of="valueConsistsOf"
                                            :default-expand-level="Infinity"
                                            :search-nested="true"                                                
                                            placeholder='Select Ledger account'
                                            v-if="renderOptionComponent"
                                        />
                                        <div class="invalid-feedback" v-if="errors.type_id">
                                            {{errors.type_id[0]}}
                                        </div>
                                    </div>
                            
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer"> 
                        <button type="submit" class="btn btn-primary " :disabled="disabled">
                            <span v-show="isSubmit">
                                <i class="fas fa-spinner fa-spin" ></i>
                            </span>{{ btn }} 
                        </button>
                        
                    </div>
                </form>
            </div>
        </Modal>


        <div class="row">
            <div class="col-md-12 ">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :columns="columns" 
                            :sortKey="tableData.sortKey"  
                            @sort="sortBy" 
                            v-if="!loading">
                            <template #header > 
                                <div class="tableFilters" style="margin-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="control" style="float: left;">
                                                <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                <div class="select" style="float: left;">
                                                    <select class="form-select" v-model="tableData.length" @change="getLedgerAccountTypeDefaultItems()">
                                                        <option value="5" selected="selected">5</option>
                                                        <option value="10" selected="selected">10</option>
                                                        <option value="25">25</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                    </select>
                                                </div>
                                                <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-2">
                                             
                                        </div>
                                        <div class="col-md-4">
                                            <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="getLedgerAccountTypeDefaultItems()">
                                        </div>
                                    </div>
                                </div>   
                            </template> 
                            <template #body > 
                                <tbody v-if="items.length > 0">
                                    <tr class="border" v-for="(item, i) in items" :key="i">
                                        <td class="text-center">{{ i + 1 }}</td>
                                        <td>{{ item.type_category }}</td>
                                        <td>{{ item.acc_type }}</td>
                                        <td>{{ '['+item.account_types.type_code+'] -- '+item.account_types.type_name }}</td>
                                        <td>
                                            <div class="dropdown float-end">
                                                <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i class="mdi mdi-dots-vertical"></i>
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">
                                                    <!-- item-->
                                                    <a href="javascript:void(0);" class="dropdown-item text-warning" @click="edit(item)"><i class="mdi mdi-circle-edit-outline me-1"></i>Edit</a>
                                                    <a href="javascript:void(0);" class="dropdown-item text-danger" @click="deleteItem(item)"><i class="mdi mdi-delete-outline me-1"></i>Remove</a>
                                                </div>
                                            </div> 
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="3"> No Data Available Here!</td>
                                    </tr>
                                </tbody>
                            </template> 
                            <template #footer>
                                <Pagination 
                                    :pagination="pagination"  
                                    :language="lang"
                                    @onChangePage="setPage" > 
                                </Pagination> 
                            </template> 
                        </Datatable>

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row">
                                <div class="col-md-5"></div>
                                <div class="col-md-2">
                                    <img src="../../assets/image/loading.gif" alt="Loading..." style="width: 130px;">
                                </div>
                                <div class="col-md-5"></div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "./../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'LedgerCreateDefaultSettings',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
        type: Object,
        default: () => {
            return {
            lengthMenu: null,
            info: null,
            zeroRecords: null, 
            search: null
            }
        },
        },
    },  
    data() {
        return {
            loading: true,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            isSubmit:false,
            errors: {},
            btn:'Create',
            items: [],
            type_category_options: [],
            acc_type_options: [],
            ledger_account_types: [],
            valueConsistsOf: 'BRANCH_PRIORITY',
            normalizer(node) {
                return {
                    id: node.id +'___'+node.code,
                    label: '['+ node.code +'] '+ node.name,
                    // isDisabled: disable_item,
                    children: node.children,
                    // children_data
                }
            },
            form: new Form({
                id: '',
                type_category: '',
                acc_type: '',
                type_id: null,
            }), 
            multiclasses: { 
              clear: '',
              clearIcon: '', 
            }, 
            renderOptionComponent: true,

            columns: [       
                {
                    label: 'SL',
                    name: '',           
                    width: '5%'
                },   
                {
                    label: 'Tyepe Category',
                    name: 'type_category',
                    width: '15%'
                },
                {
                    label: 'Account Type',
                    name: 'acc_type',
                    width: '10%'
                },
                {
                    label: 'Type for Ledger',
                    name: 'account_types.type_name',
                    width: '15%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false,
                    isAction: true,
                    width: '5%'

                }
            ],
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                sortKey: 'type_category',
            },
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }
        };
    },
    created() {
        this.fetchTypeCategoryAndAccTypes();
        this.fetchLedgerAccountTypes();
        this.getLedgerAccountTypeDefaultItems();
    },
    methods: { 

        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },

        createModal: function() {
            this.forceRerender();
            this.modalActive = !this.modalActive;
            if(!this.modalActive) {
                this.editMode = false;
                this.btn='Create';
                this.form.reset();
            }
            this.errors = '';
            this.isSubmit = false;
        },

        fetchTypeCategoryAndAccTypes() {
            axios.get(this.apiUrl+'/acc_ledger_default_settings/getTypeCategoryAndAccTypes', this.headerjson)
            .then((resp) => {
                console.log("resp.data.data", resp.data.data);
                let type_categories = resp.data.data.type_categories;
                let acc_types = resp.data.data.acc_types;

                this.type_category_options = type_categories.map((item, index) => {return {label: item, value: item}});
                this.acc_type_options = acc_types.map((item, index) => {return {label: item, value: item}});
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {

            });
        },

        fetchLedgerAccountTypes() {
            axios.get(this.apiUrl+'/account_types/getHierarchy', this.headerjson)
            .then((resp) => {
                this.ledger_account_types = resp.data.data.account_types;  
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message)
            })
            .finally(() => {
                // this.loading = false;
            });
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.createModal();
            
            this.form.fill(item);
            this.form.type_id = item.type_id +'___'+ item.account_types.type_code;
            this.forceRerender();

        },

        submitLedgerCreateDefaultSettingsForm: function(e) { 

            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();           
            formData.append('type_category', this.form.type_category);
            formData.append('acc_type', this.form.acc_type);
            formData.append('type_id', this.form.type_id);
            if(this.editMode){
                formData.append('_method', 'put');
                var postEvent = axios.post(this.apiUrl+'/acc_ledger_default_settings/'+this.form.id, formData, this.headers);
            }else{ 
                var postEvent = axios.post(this.apiUrl+'/acc_ledger_default_settings', formData, this.headers);
            }         

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.createModal();
                    this.getLedgerAccountTypeDefaultItems();
                    this.fetchTypeCategoryAndAccTypes();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                }

            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            });
        },

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },

        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/acc_ledger_default_settings/'+item.id, this.headerjson) 
                    .then(res => {
                        if(res.status == 200){  
                            this.getLedgerAccountTypeDefaultItems();
                            this.fetchTypeCategoryAndAccTypes();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },


        // For Pagination 
        getLedgerAccountTypeDefaultItems(url = this.apiUrl+'/acc_ledger_default_settings/list') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData, headers: this.headerparams})
            .then((response) => {
                let data = response.data.data;
                if(this.tableData.draw = data.draw) {
                    this.items = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.getLedgerAccountTypeDefaultItems();
        },
        setPage(data){  
            this.getLedgerAccountTypeDefaultItems(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

    },

    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>

<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 600px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

.actions_btn a {
    margin-right: 7px;
}
</style>